<div class="elementCont" id="separator-{{indexofelement}}">
    <div id="separator-div-{{indexofelement}}" style="height:1px;background-color:#888 ;" #separatorDiv>
    </div>
    
    </div>
